<div class="row">
  <div class="col-xs-12">
    <div class="small footer-default">
      {{ 'PARTECIPANT_LTI.RESULTS.SELECT_YEAR' | translate }}
    </div>
    <select
      id="selectYearEl"
      class="form-control"
      name="sel-activity"
      [(ngModel)]="currentYear"
    >
      <option *ngFor="let year of getYears()" [ngValue]="year">
        {{ year }}
      </option>
    </select>

    <div id="widgetsContainer">
      <div
        id="bonusAccrued"
        class="widget"
        [ngClass]="{ collapsed: !expandAccrued, expanded: expandAccrued }"
      >
        <div class="widgetHeader">
          <div class="widgetHeaderInfo">
            <div class="medium bold widgetTitle">
              {{
                'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.TITLE' | translate
              }}
            </div>
            <div class="veryBig widgetAmount">
              {{ formatNumber(getAmount('accrued'), 0) }}
            </div>
          </div>
          <div class="widgetExpandAction" *ngIf="!expandAccrued">
            <i class="fa fa-search-plus fa-3x" (click)="expand('accrued')"></i>
          </div>
          <div class="display-flex-right flex-fill-width" *ngIf="expandAccrued">
            <div class="widgetProgressAccrued">
              <progressbar
                type="warning"
                [value]="getAmount('accrued')"
                [max]="getAmount('accrued_max')"
              ></progressbar>
            </div>
            <div class="" style="width: 10px"></div>
            <div class="widgetExpandAction">
              <i
                class="fa fa-search-minus fa-3x"
                (click)="collapse('accrued')"
              ></i>
            </div>
          </div>
        </div>

        <div class="widgetBody" *ngIf="!expandAccrued">
          <div class="widgetProgressAccrued">
            <progressbar
              type="warning"
              [value]="getAmount('accrued')"
              [max]="getAmount('accrued_max')"
            ></progressbar>
          </div>
          <div class="display-flex-center" id="accruedCollapsedDetails">
            <div class="accruedCollapsedDetailsItem">
              <div class="medium accruedCollapsedDetailsAmount">
                {{ formatNumber(getAmount('accrued_payable')) }}
              </div>
              <div class="small">
                {{
                  'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.PAYABLE'
                    | translate
                }}
              </div>
            </div>
            <div class="accruedCollapsedDetailsItem">
              <div class="medium accruedCollapsedDetailsAmount">
                {{ formatNumber(getAmount('accrued_deferred')) }}
              </div>
              <div class="small">
                {{
                  'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.DEFERRED'
                    | translate
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="widgetBody" id="expandAccrued" *ngIf="expandAccrued">
          <div class="tablesSummary">
            <div class="greyTable">
              <div class="display-flex-space-between medium">
                <span>
                  {{
                    'ADMIN_LTI.GATEWAYS.BODY.TARGET_BONUS'
                      | translate
                      | uppercase
                  }}
                </span>
                <span>{{ getSummaryTargetBonus(currentYear) }}</span>
              </div>
            </div>

            <div class="yellowTable" *ngIf="plan.Gateways.length > 0">
              <div class="display-flex-space-between medium bold">
                <span>
                  {{ 'ADMIN_LTI.RESULTS.TARGET_BONUS_MULTIPLIER' | translate }}
                </span>
                <span>{{ getSummaryTargetBonusMultiplier(currentYear) }}%</span>
              </div>
              <table class="table">
                <thead>
                  <tr>
                    <th class="wide-col"></th>
                    <th class="narrow-col">
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.TYPE'
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.TARGET_VALUE'
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.TARGET_THRESHOLD'
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.BONUS_SENSIVITY'
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.RESULT_VALUE'
                          | translate
                      }}
                    </th>
                    <th>
                      %{{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.TARGET'
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.MULTIPLIER'
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.WEIGHT'
                          | translate
                      }}%
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let item of plan.Gateways">
                    <tr>
                      <td class="wide-col">{{ item.Goal.Name }}</td>
                      <td class="narrow-col">{{ item.ConsultationType }}</td>
                      <td>{{ getObjectTargetValue(item, currentYear) }}</td>
                      <td>{{ getObjectTargetThreshold(item, currentYear) }}</td>
                      <td>{{ getObjectSensivity(item, currentYear) }}</td>
                      <td>{{ getObjectCurrentValue(item, currentYear) }}</td>
                      <td>
                        {{
                          formatNumber(
                            getObjectCalcTargetValue(item, currentYear),
                            0
                          )
                        }}%
                      </td>
                      <td [ngClass]="getIsOverTargetValue(item, currentYear)">
                        <b>{{ getMultiplier(item, currentYear) }}%</b>
                      </td>
                      <td>{{ item.Weight }}%</td>
                      <th *ngIf="item.Name">
                        <i
                          class="fa fa-caret-down pointer"
                          [ngClass]="{
                            'fa-caret-down': !item.showDetail,
                            'fa-caret-up': item.showDetail
                          }"
                          (click)="item.showDetail = !item.showDetail"
                        ></i>
                      </th>
                    </tr>
                    <tr *ngIf="item.showDetail">
                      <td [attr.colspan]="10">{{ item.Name }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>

            <div class="greyTable">
              <div class="display-flex-space-between medium">
                <span>
                  {{
                    'ADMIN_LTI.GATEWAYS.BODY.ADMITTED_BONUS'
                      | translate
                      | uppercase
                  }}
                </span>
                <span>{{ getSummaryAdmittedBonus(currentYear) }}</span>
              </div>
            </div>

            <div class="yellowTable" *ngIf="plan.Objectives.length > 0">
              <div class="display-flex-space-between medium bold">
                <span>
                  {{ 'ADMIN_LTI.RESULTS.BONUS_MULTIPLIER' | translate }}
                </span>
                <span>{{ getSummaryBonusMultiplier(currentYear) }}%</span>
              </div>
              <table class="table">
                <thead>
                  <tr>
                    <th class="wide-col"></th>
                    <th class="narrow-col">
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.TYPE'
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.TARGET_VALUE'
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.TARGET_THRESHOLD'
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.BONUS_SENSIVITY'
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.RESULT_VALUE'
                          | translate
                      }}
                    </th>
                    <th>
                      %{{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.TARGET'
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.MULTIPLIER'
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.WEIGHT'
                          | translate
                      }}%
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let item of plan.Objectives">
                    <tr>
                      <td class="wide-col">{{ item.Goal.Name }}</td>
                      <td class="narrow-col">{{ item.ConsultationType }}</td>
                      <td>{{ getObjectTargetValue(item, currentYear) }}</td>
                      <td>{{ getObjectTargetThreshold(item, currentYear) }}</td>
                      <td>{{ getObjectSensivity(item, currentYear) }}</td>
                      <td>{{ getObjectCurrentValue(item, currentYear) }}</td>
                      <td>
                        {{
                          formatNumber(
                            getObjectCalcTargetValue(item, currentYear),
                            0
                          )
                        }}%
                      </td>
                      <td [ngClass]="getIsOverTargetValue(item, currentYear)">
                        <b>{{ getMultiplier(item, currentYear) }}%</b>
                      </td>
                      <td>{{ item.Weight }}%</td>
                      <th *ngIf="item.Name">
                        <i
                          class="fa fa-caret-down pointer"
                          [ngClass]="{
                            'fa-caret-down': !item.showDetail,
                            'fa-caret-up': item.showDetail
                          }"
                          (click)="item.showDetail = !item.showDetail"
                        ></i>
                      </th>
                    </tr>
                    <tr *ngIf="item.showDetail">
                      <td [attr.colspan]="10">{{ item.Name }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>

            <div class="greyTable">
              <div
                class="display-flex-space-between medium text-bold border-bottom"
              >
                <span class="">
                  {{
                    'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.TITLE'
                      | translate
                  }}
                </span>
                <span>{{ getSummaryBonusAccrued(currentYear) }}</span>
              </div>
              <div
                class="display-flex-space-between medium text-bold border-bottom"
              >
                <span>
                  {{
                    'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.PAYABLE'
                      | translate
                  }}
                </span>
                <span>{{ getSummaryPayable(currentYear) }}</span>
              </div>
              <div
                class="display-flex-space-between medium text-bold border-bottom"
              >
                <span>
                  {{
                    'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.DEFERRED'
                      | translate
                  }}
                </span>
                <span>{{ getSummaryDeferred(currentYear) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="bonusPayable"
        class="widget"
        [ngClass]="{ collapsed: !expandPayable, expanded: expandPayable }"
      >
        <div class="widgetHeader">
          <div class="widgetHeaderInfo">
            <div class="medium bold widgetTitle">
              {{
                'PARTECIPANT_LTI.RESULTS.BONUS_PAYABLE_WIDGET.TITLE' | translate
              }}
            </div>
            <div class="veryBig widgetAmount">
              {{ formatNumber(getAmount('payable'), 0) }}
            </div>
          </div>
          <!-- <div class="widgetExpandAction" *ngIf="!expandPayable"><i class="fa fa-search-plus fa-3x" (click)="expand('payable')"></i></div>
            <div class="widgetExpandAction" *ngIf="expandPayable"><i class="fa fa-search-minus fa-3x" (click)="collapse('payable')"></i></div> -->
        </div>

        <div class="widgetBody">
          <div class="display-flex-space-between">
            <div
              class=""
              style="with: 100%; height: 200px"
              *ngIf="plan.PayoutStructure.PayoutType !== 'Cash'"
            >
              <canvas #chart id="chartContainer"></canvas>
              <!-- <canvas baseChart *ngIf="expandPayable"
                  [data]="getBonusPayableGraphData()"
                  [labels]="getBonusPayableGraphDataLabels()"
                  [chartType]="'pie'"
                  [options]="getBonusPayableGraphOptions()"
                  [colors]="getBonusPayableGraphDataColors()"
                  [legend]="'true'">
                </canvas>
                <canvas baseChart *ngIf="!expandPayable"
                  [data]="getBonusPayableGraphData()"
                  [labels]="getBonusPayableGraphDataLabels()"
                  [chartType]="'pie'"
                  [options]="getBonusPayableGraphOptions()"
                  [colors]="getBonusPayableGraphDataColors()"
                  [legend]="'true'">
                </canvas> -->
            </div>

            <div *ngIf="expandPayable" class="flex-fill" style="width: 300px">
              <progressbar
                type="warning"
                [value]="getBonusPayableWidgetAccrued(currentYear)"
                [max]="getBonusPayableWidgetAccruedProgressMax(currentYear)"
              ></progressbar>

              <div class="small">
                <span>
                  {{ 'ADMIN_LTI.RESULTS.ACCRUED_IN' | translate | uppercase }}
                </span>
              </div>
              <div class="display-flex-left flex-align-center">
                <div
                  class=""
                  *ngFor="let year of getYearsUntilCurrentYear(currentYear)"
                >
                  <i class="fa fa-square"></i>
                  &nbsp;{{ year }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="bonusBank"
        class="widget"
        [ngClass]="{ collapsed: !expandBonusBank, expanded: expandBonusBank }"
      >
        <div class="widgetHeader">
          <div class="widgetHeaderInfo">
            <div class="medium bold widgetTitle">
              {{
                'PARTECIPANT_LTI.RESULTS.BONUS_BANK_WIDGET.TITLE' | translate
              }}
            </div>
            <div class="veryBig widgetAmount">
              {{ formatNumber(getBonusBankClosing(currentYear), 0) }}
            </div>
          </div>
          <div class="widgetExpandAction" *ngIf="!expandBonusBank">
            <i
              class="fa fa-search-plus fa-3x"
              (click)="expand('bonusbank')"
            ></i>
          </div>
          <div class="widgetExpandAction" *ngIf="expandBonusBank">
            <i
              class="fa fa-search-minus fa-3x"
              (click)="collapse('bonusbank')"
            ></i>
          </div>
        </div>

        <div class="widgetBody" *ngIf="!expandBonusBank">
          <div class="display-flex-left">
            <div class="text-bold" style="flex: 0 0 150px; padding-right: 10px">
              {{ 'ADMIN_LTI.RESULTS.BONUS_BANK_OPENING' | translate }}
            </div>
            <progressbar
              style="flex: 1"
              type="warning"
              [value]="getBonusBankOpening(currentYear)"
              [max]="getMax(currentYear)"
            ></progressbar>
            <div class="text-right" style="flex: 0 0 100px; padding-left: 10px">
              {{ formatNumber(getBonusBankOpening(currentYear), 0) }}
            </div>
          </div>
          <div class="display-flex-left">
            <div class="" style="flex: 0 0 150px; padding-right: 10px">
              {{
                'PARTECIPANT_LTI.RESULTS.BONUS_BANK_WIDGET.PAST_PAYABLE'
                  | translate
              }}
            </div>
            <progressbar
              type="grey"
              [value]="getBonusBankPastPayable()"
              [max]="getMax(currentYear)"
            ></progressbar>
            <div class="text-right" style="flex: 0 0 100px; padding-left: 10px">
              {{ formatNumber(getBonusBankPastPayable(), 0) }}
            </div>
          </div>
          <div class="display-flex-left">
            <div class="" style="flex: 0 0 150px; padding-right: 10px">
              {{ currentYear }}
              {{
                'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.DEFERRED'
                  | translate
              }}
            </div>
            <progressbar
              style="flex: 1"
              type="warning"
              [value]="getBonusBankDeferred()"
              [max]="getMax(currentYear)"
            ></progressbar>
            <div class="text-right" style="flex: 0 0 100px; padding-left: 10px">
              {{ formatNumber(getBonusBankDeferred(), 0) }}
            </div>
          </div>
          <div class="display-flex-left">
            <div class="text-bold" style="flex: 0 0 150px; padding-right: 10px">
              {{ 'ADMIN_LTI.CORRECTIVE.BODY.ROLLING_BONUS_BANK' | translate }}
            </div>
            <progressbar
              style="flex: 1"
              type="warning"
              [value]="getBonusBankRolling(currentYear)"
              [max]="getMax(currentYear)"
            ></progressbar>
            <div
              class="text-bold text-right"
              style="flex: 0 0 100px; padding-left: 10px"
            >
              {{ formatNumber(getBonusBankRolling(currentYear), 0) }}
            </div>
          </div>
        </div>

        <div class="widgetBody" *ngIf="expandBonusBank">
          <div class="tablesSummary">
            <div class="greyTable">
              <div class="display-flex-space-between medium">
                <span>
                  {{
                    'ADMIN_LTI.RESULTS.BONUS_BANK_OPENING'
                      | translate
                      | uppercase
                  }}
                </span>
                <span>{{ getBonusBankWidgetOpening(currentYear) }}</span>
              </div>
              <div class="display-flex-space-between medium">
                <span>
                  {{
                    'PARTECIPANT_LTI.RESULTS.BONUS_BANK_WIDGET.PAST_PAYABLE'
                      | translate
                  }}
                </span>
                <span>{{ getBonusBankWidgetPastPayable(currentYear) }}</span>
              </div>
              <div class="display-flex-space-between medium">
                <span>
                  {{ currentYear }}
                  {{
                    'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.DEFERRED'
                      | translate
                  }}
                </span>
                <span>{{ getBonusBankWidgetDeferred(currentYear) }}</span>
              </div>
            </div>

            <div class="greyTable">
              <div class="display-flex-space-between medium">
                <span>
                  {{
                    'ADMIN_LTI.RESULTS.BONUS_BANK_BASE' | translate | uppercase
                  }}
                </span>
                <span>{{ getBonusBankWidgetBonusBankBase(currentYear) }}</span>
              </div>
            </div>

            <div class="yellowTable" *ngIf="plan.Correctives.length > 0">
              <div class="display-flex-space-between medium bold">
                <span>
                  {{
                    'ADMIN_LTI.CORRECTIVE.BODY.BONUS_BANK_MULTIPLIER'
                      | translate
                  }}
                </span>
                <span>
                  {{ getBonusBankWidgetBonusBankMutiplier(currentYear) }}%
                </span>
              </div>
              <table class="table">
                <thead>
                  <tr>
                    <th></th>
                    <th>
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.TYPE'
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.TARGET_VALUE'
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.TARGET_THRESHOLD'
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.BONUS_SENSIVITY'
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.RESULT_VALUE'
                          | translate
                      }}
                    </th>
                    <th>
                      %{{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.TARGET'
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.MULTIPLIER'
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.WEIGHT'
                          | translate
                      }}%
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let item of plan.Correctives">
                    <tr>
                      <td>{{ item.Goal.Name }}</td>
                      <td>{{ item.ConsultationType }}</td>
                      <td>{{ getObjectTargetValue(item, currentYear) }}</td>
                      <td>{{ getObjectTargetThreshold(item, currentYear) }}</td>
                      <td>{{ getObjectSensivity(item, currentYear) }}</td>
                      <td>{{ getObjectCurrentValue(item, currentYear) }}</td>
                      <td>
                        {{ getObjectCalcTargetValue(item, currentYear) }}%
                      </td>
                      <td [ngClass]="getIsOverTargetValue(item, currentYear)">
                        <b>{{ getMultiplier(item, currentYear) }}%</b>
                      </td>
                      <td>{{ item.Weight }}%</td>
                      <th *ngIf="item.Name">
                        <i
                          class="fa fa-caret-down pointer"
                          [ngClass]="{
                            'fa-caret-down': !item.showDetail,
                            'fa-caret-up': item.showDetail
                          }"
                          (click)="item.showDetail = !item.showDetail"
                        ></i>
                      </th>
                    </tr>
                    <tr *ngIf="item.showDetail">
                      <td [attr.colspan]="10">{{ item.Name }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>

            <div class="greyTable">
              <div class="display-flex-space-between medium">
                <span class="text-bold">
                  {{
                    'ADMIN_LTI.CORRECTIVE.BODY.ROLLING_BONUS_BANK'
                      | translate
                      | uppercase
                  }}
                </span>
                <span class="text-bold">
                  {{ getBonusBankWidgetBonusBank(currentYear) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
